<template>
  <div class="content-filter">
    <header-mobile-page v-if="$mq === 'mobile'"
                        :label="child.name" />

    <content-filter-header class="header" />

    <content-filter :modeId="child.default_mode_id" />
  </div>
</template>

<script>
  import ContentFilter from '@/components/Child/ChildContentFilter/ContentFilter'
  import ContentFilterHeader from '@/components/Child/ChildContentFilter/ContentFilterHeader'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  export default {
    components: {
      ContentFilter,
      ContentFilterHeader,
      HeaderMobilePage
    },

    props: {
      childId: {
        type: String,
        required: true
      }
    },

    computed: {
      child() {
        return this.getChildById(this.childId)
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      })
    },
  }
</script>

<style lang="scss" scoped>
  .content-filter {
    width: 100%;
    height: auto;

    padding: 0 20px 10px 20px;

    .header {
      color: map.get($colors, primary);
      margin-bottom: 20px;

      :deep(.header-title) {
        font-size: 24px;
      }
    }
  }
</style>